import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import menu from './modules/menu'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        app,
        menu
    },
    getters,
    strict: process.env.NODE_ENV !== 'production' // 严格模式仅开发环境
})